<template>
  <div v-if="total > 0" class="paginacion">
    <p class="paginacion-info">
      Mostrando <strong>{{ desde }}–{{ hasta }}</strong> de <strong>{{ total }}</strong> {{ etiqueta }}
    </p>
    <nav v-if="totalPaginas > 1" class="paginacion-controles" aria-label="Paginación del listado">
      <button class="pag-btn pag-flecha" :disabled="pagina === 1 || cargando" aria-label="Página anterior"
        @click="cambiar(pagina - 1)">
        <i class="bi bi-chevron-left"></i><span class="pag-flecha-texto">Anterior</span>
      </button>
      <template v-for="(item, i) in paginasVisibles">
        <span v-if="item === '…'" :key="'elipsis-' + i" class="pag-elipsis" aria-hidden="true">…</span>
        <button v-else :key="'pagina-' + item" class="pag-btn" :class="{ activo: item === pagina }"
          :aria-current="item === pagina ? 'page' : null" :disabled="cargando" @click="cambiar(item)">
          {{ item }}
        </button>
      </template>
      <button class="pag-btn pag-flecha" :disabled="pagina === totalPaginas || cargando" aria-label="Página siguiente"
        @click="cambiar(pagina + 1)">
        <span class="pag-flecha-texto">Siguiente</span><i class="bi bi-chevron-right"></i>
      </button>
    </nav>
  </div>
</template>

<script>
// Barra de paginación para listados que vienen paginados desde el backend (Laravel paginate).
export default {
  name: 'PaginacionListado',
  props: {
    pagina: { type: Number, required: true },
    totalPaginas: { type: Number, required: true },
    total: { type: Number, required: true },
    porPagina: { type: Number, required: true },
    enPagina: { type: Number, required: true }, // cuántos registros trae la página actual
    cargando: { type: Boolean, default: false },
    etiqueta: { type: String, default: 'registros' },
  },
  computed: {
    desde() {
      return (this.pagina - 1) * this.porPagina + 1
    },
    hasta() {
      return (this.pagina - 1) * this.porPagina + this.enPagina
    },
    // Siempre la primera y la última; alrededor de la actual, con "…" en los saltos: 1 … 5 6 7 … 19
    paginasVisibles() {
      const total = this.totalPaginas, actual = this.pagina
      if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)

      let inicio = Math.max(2, actual - 1), fin = Math.min(total - 1, actual + 1)
      if (actual <= 3) { inicio = 2; fin = 4 }
      if (actual >= total - 2) { inicio = total - 3; fin = total - 1 }

      const paginas = [1]
      if (inicio > 2) paginas.push('…')
      for (let i = inicio; i <= fin; i++) paginas.push(i)
      if (fin < total - 1) paginas.push('…')
      paginas.push(total)
      return paginas
    },
  },
  methods: {
    cambiar(n) {
      if (n < 1 || n > this.totalPaginas || n === this.pagina) return
      this.$emit('cambiar', n)
    },
  },
}
</script>

<style scoped>
/* Misma línea visual que .filter-card (borde, radio y sombra) */
.paginacion {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px 20px;
  flex-wrap: wrap;
  margin: 16px 0 24px;
  padding: 10px 16px;
  background: #fff;
  border: 1px solid #e8eaf6;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(63, 81, 181, 0.06);
}
.paginacion-info {
  margin: 0;
  font-size: 0.8rem;
  color: #6b7085;
}
.paginacion-info strong {
  color: #2e3247;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.paginacion-controles {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pag-btn {
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #4a4f66;
  font-size: 0.82rem;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}
.pag-btn:hover:not(:disabled):not(.activo) {
  background: #f3f4fb;
  color: #3f51b5;
}
.pag-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(63, 81, 181, 0.22);
}
.pag-btn.activo {
  background: #3f51b5;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(63, 81, 181, 0.25);
  cursor: default;
}
.pag-flecha {
  border-color: #e8eaf6;
  color: #5b6078;
}
.pag-flecha:hover:not(:disabled) {
  border-color: #c5cae9;
}
.pag-flecha .bi {
  font-size: 0.75rem;
}
.pag-btn:disabled:not(.activo) {
  opacity: 0.4;
  cursor: not-allowed;
}
.pag-elipsis {
  min-width: 22px;
  text-align: center;
  color: #a3a7b8;
  font-size: 0.82rem;
  user-select: none;
}
@media (max-width: 767.98px) {
  .paginacion {
    flex-direction: column;
    justify-content: center;
    padding: 12px;
  }
  .pag-flecha-texto {
    display: none;
  }
  .pag-flecha {
    padding: 0;
  }
}
</style>
